import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Form } from 'react-bootstrap'

import {
  handleHospitalAdmissionChartFieldChange,
  submitChartHospitalAdmissionInfo,
} from '../reducers/hospitalAdmissionFormReducer'
import {
  handleChartFieldChange,
} from '../reducers/chartFormReducer'

import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import CheckboxesWithOptionalTextField from '../../../components/CheckboxesWithOptionalTextField'
import FormInput from '../../../components/FormInput'
import WarningModal from '../../../components/WarningModal'


const HospitalAdmissionForm = (props) => {

  const initialWarningModalState = {
    show: false,
    headerText: '',
    bodyText: '',
  }

  const [warningModalConfig, changeShowWarningModal] = useState(initialWarningModalState)

  const handleChange = (e) => {
    const { name, value } = e.target
    return props.handleHospitalAdmissionChartFieldChange(name, value)
  }

  const handleAdmissionDateChange = (date) => {
    props.handleHospitalAdmissionChartFieldChange('admissionDate', date)
    props.handleChartFieldChange('chartDateErrorMessage', '')
    if ((date instanceof Date && !isNaN(date)) || date === null) {
      const hospitalAdmission = {...props, admissionDate: date, 'chartDateErrorMessage': 'admissionDate'}
      return props.submitChartHospitalAdmissionInfo(hospitalAdmission)
    }
  }

  const getHelperText = (key) => {
    if (!props[`${key}`]) {
      if (chartDateErrorMessage && chartDateErrorMessage !== '' && chartDateErrorMessage.includes('[')) {
        let splitError = chartDateErrorMessage.split('[')[1].split(']')[0]
        let arr = splitError.split('_')
        let joined = arr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
        let camelCase = joined.charAt(0).toLowerCase() + joined.slice(1).split(']')[0]
        if (key === camelCase || camelCase.includes(`${key}`)) {
          return chartDateErrorMessage.split('[')[0]
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }

  const resetNestedValuesToEmpty = (bool, fieldName, optionsWithNestedFields) => {
    if (bool === false && optionsWithNestedFields[fieldName]) {
      const nestedOptions = optionsWithNestedFields[fieldName]
      nestedOptions.forEach(option => {
        props.handleHospitalAdmissionChartFieldChange(option, '')
      })
    }
  }

  const handleAdmissionTypeChange = (e) => {
    const { name, value } = e.target
    if (name === 'admissionType' && value.toLowerCase() !== 'other') {
      props.handleHospitalAdmissionChartFieldChange('admissionTypeOtherText', '')
    }
    return props.handleHospitalAdmissionChartFieldChange(name, value)
  }

  const handleInfectionRiskFactorsSelect = (name, value) => {
    let showWarningModal = false
    if ((name === 'no_carbapenem_bacterial_infection_risk_factors' && value === true)) {
      showWarningModal = !!infectionRiskFactorsOptions.find(option => {
        return option.fieldName !== 'no_carbapenem_bacterial_infection_risk_factors' && props[option.fieldName] === true
      })
    } else if (props.no_carbapenem_bacterial_infection_risk_factors === true && value === true) {
      showWarningModal = true
    }

    if (showWarningModal) {
      return changeShowWarningModal({
        show: true,
        headerText: "Pre-existing or concurrent medical conditions validation",
        bodyText: 'The "None" option cannot be selected for the field "Risk factors for Carbapenem-Resistant Gram-negative bacterial infection" if other options have been selected.',
      })
    }

    const optionsWithNestedFields = {
      hospitalAdmissionsInPastSixMonths: ['hospitalAdmissionsInPastSixMonthsText'],
      traumaSurgery: ['traumaSurgeryText'],
      recentTravelToForeignCountry: ['recentTravelToForeignCountryText'],
      bacterialInfectionRiskFactorsOther: ['bacterialInfectionRiskFactorsOtherText'],
    }

    resetNestedValuesToEmpty(value, name, optionsWithNestedFields)

    return handleCheckboxSelect(name, value)
  }
  

  const handleAdditionalDiagnosesSelect = (name, value) => {
    let showWarningModal = false
    if ((name === 'no_pre_existing_conditions' && value === true)) {
      showWarningModal = !!additionalDiagnosesOptions.find(option => {
        return option.fieldName !== 'no_pre_existing_conditions' && props[option.fieldName] === true
      })
    } else if (props.no_pre_existing_conditions === true && value === true) {
      showWarningModal = true
    }

    if (showWarningModal) {
      return changeShowWarningModal({
        show: true,
        headerText: "Pre-existing or concurrent medical conditions validation",
        bodyText: 'The "None" option cannot be selected for the field "Any relevant pre-existing or concurrent medical conditions prior to the time of hospitalization" if other options have been selected.',
      })
    }

    const optionsWithNestedFields = {
      metastaticSolidTumor: ['metastaticSolidTumorPrimarySite', 'metastaticSolidTumorMetastaticSites'],
      hiv: ['hiv_treatment'],
      pregnancy: ['pregnancy_trimester'],
      additionalDiagnosesOther: ['additionalDiagnosesOtherText'],
    }

    resetNestedValuesToEmpty(value, name, optionsWithNestedFields)

    return handleCheckboxSelect(name, value)
  }


  const handleCheckboxSelect = (name, value) => {
    changeShowWarningModal(initialWarningModalState)
    props.handleHospitalAdmissionChartFieldChange(name, value)
    const copyProps = { ...props, [name]: value }
    return props.submitChartHospitalAdmissionInfo(copyProps)
  }

  const handleBlur = () => {
    props.submitChartHospitalAdmissionInfo(props)
  }

  const getRequired = (options) => {
    if (options.length !== 0) {
      let required = true
      options.forEach(option => {
        if (props[option.fieldName]) {
          required = false
        }
      })
      return required
    } else {
      return null
    }
  }

  const {
    admissionDate,
    admissionType,
    admissionTypeOtherText,
    admissionDiagnoses,
    chartForReview,
    chartDateErrorMessage,
    savingChartPhase
  } = props

  const admissionTypeOptions = [
    {value: 'Emergency or Urgent Admission',
    fieldName: 'emergencyOrUrgentAdmission'},
    {value: 'Direct Transfer from Another Medical Care Facility',
    fieldName: 'directTransfer'},
    {value: 'Scheduled Admission',
    fieldName: 'scheduledAdmission'},
    {value: 'Other',
    fieldName: 'other',
    textFields: [{
      displayName: 'Please Specify',
      fieldName: 'admissionTypeOtherText'
    }]}
  ]

  const additionalDiagnosesOptions = [
    {displayName: 'Myocardial Infarction',
    fieldName: 'myocardialInfarction',
    infoText: 'History of definite or probable MI',
    textFields: []},

    {displayName: 'Congestive Heart Failure ',
    fieldName: 'congestiveHeartFailure',
    textFields: []},

    {displayName: 'Peripheral Vascular Disease',
    fieldName: 'peripheralVascularDisease',
    infoText: 'Intermittent claudication or past bypass for chronic arterial insufficiency, history of gangrene or acute arterial insufficiency',
    textFields: []},

    {displayName: 'Cerebrovascular Disease or Transient Ischemic Attacks',
    fieldName: 'cerebrovascularDiseaseTransientIschemicAttacks',
    infoText: 'History of a cerebrovascular accident with minor or no residua and transient ischemic attacks',
    textFields: []},

    {displayName: 'Dementia',
    fieldName: 'dementia',
    infoText: 'Chronic cognitive deficit',
    textFields: []},

    {displayName: 'Hemiplegia, paraplegia, or quadriplegia',
    fieldName: 'hemiplegia',
    textFields: []},

    {displayName: 'Chronic Pulmonary Disease',
    fieldName: 'chronicPulmonaryDisease',
    textFields: []},

    {displayName: 'Cystic Fibrosis',
    fieldName: 'cysticFibrosis',
    textFields: []},

    {displayName: 'Bronchiectasis',
    fieldName: 'bronchiectasis',
    textFields: []},

    {displayName: 'Emphysema',
    fieldName: 'emphysema',
    textFields: []},

    {displayName: 'Coronavirus Disease 2019 (COVID-19)',
    fieldName: 'covid',
    textFields: []},

    {displayName: 'Peptic Ulcer Disease',
    fieldName: 'pepticUlcerDisease',
    infoText: 'Any history of treatment for ulcer disease or history of ulcer bleeding',
    textFields: []},

    {displayName: 'Mild Liver Disease',
    fieldName: 'mildLiverDisease',
    infoText: 'Chronic hepatitis or cirrhosis without portal hypertension',
    textFields: []},

    {displayName: 'Moderate Severe Liver Disease',
    fieldName: 'moderateSevereLiverDisease',
    infoText: 'Cirrhosis and portal hypertension with or without variceal bleeding history',
    textFields: []},

    {displayName: 'Diabetes Mellitus Uncomplicated (excludes diet-controlled)',
    fieldName: 'diabetesMellitusUncomplicated',
    textFields: []},

    {displayName: 'Diabetes with End-Organ Damage',
    fieldName: 'diabetesWithEndOrganDamage',
    infoText: 'Retinopathy, neuropathy, nephropathy',
    textFields: []},

    {displayName: 'Moderate or Severe Renal Disease',
    fieldName: 'moderateOrSevereRenalDisease',
    infoText: <span>On dialysis, status post kidney transplant eGFR &lt;30 mL/min/1.73 m<sup>2</sup></span>,
    textFields: []},

    {displayName: 'Solid Tumor without Metastasis within Last 5 Years',
    fieldName: 'solidTumorWithoutMetastasisLastFiveYears',
    textFields: []},

    {displayName: 'Metastatic Solid Tumor (Stage 4)',
    fieldName: 'metastaticSolidTumor',
    textFields: [
      {displayName: 'Primary Site:',
      fieldName: 'metastaticSolidTumorPrimarySite'},
      {displayName: 'Metastatic site(s):', fieldName: 'metastaticSolidTumorMetastaticSites'}
    ]},

    {displayName: 'Leukemia (Acute or Chronic)',
    fieldName: 'leukemia',
    textFields: []},

    {displayName: 'Lymphoma',
    fieldName: 'lymphoma',
    textFields: []},

    {displayName: 'Multiple Myeloma',
    fieldName: 'multipleMyeloma',
    textFields: []},

    {displayName: 'Febrile Neutropenia',
    fieldName: 'febrileNeutropenia',
    textFields: []},

    {displayName: 'Muscular-Skeletal Abnormality/Degenerative Disease',
    fieldName: 'muscularSkeletalAbnormalityDegenerativeDisease',
    textFields: []},

    {displayName: 'Connective Tissue Disease',
    fieldName: 'connectiveTissueDisease',
    textFields: []},

    {displayName: 'Severe Burns',
    fieldName: 'severeBurns',
    textFields: []},

    {displayName: 'HIV',
    fieldName: 'hiv',
    nestedLabel: 'On treatment?',
    nestedName: 'hiv_treatment',
    selectFields: [
      {displayName: 'Yes',
      fieldName: 'hiv_treatment'},
      {displayName: 'No',
      fieldName: 'hiv_treatment'},
    ]},

    {displayName: 'Pregnancy',
    fieldName: 'pregnancy',
    nestedLabel: 'What is the approximate gestational trimester?',
    nestedName: 'pregnancy_trimester',
    selectFields: [
      {displayName: '1st',
      fieldName: 'pregnancy_trimester'},
      {displayName: '2nd',
      fieldName: 'pregnancy_trimester'},
      {displayName: '3rd',
      fieldName: 'pregnancy_trimester'},
      {displayName: `Don't Know`,
      fieldName: 'pregnancy_trimester'},
    ]},

    {displayName: 'Other',
    fieldName: 'additionalDiagnosesOther',
    textFields: [{
      displayName: 'Please Specify',
      fieldName: 'additionalDiagnosesOtherText'
    }]},

    {displayName: 'None',
      fieldName: 'no_pre_existing_conditions',
    },
  ]


  const infectionRiskFactorsOptions = [
    {displayName: 'History of carbapenem-resistant Gram-negative bacterial infections or colonization within last 6 months.',
    fieldName: 'carbapenemBacterialInfectionHistory',
    textFields: []},

    {displayName: 'Had been hospitalized in past 6 months',
    fieldName: 'hospitalAdmissionsInPastSixMonths',
    textFields: [
      {displayName: 'Please specify the diagnosis and when the last hospitalization occurred',
      fieldName: 'hospitalAdmissionsInPastSixMonthsText'}
    ]},

    {displayName: 'Transplant within last 90 days',
    fieldName: 'transplantWithinNinetyDays',
    textFields: []},

    {displayName: 'Trauma, major surgery within 3 months before initiation of cefiderocol treatment:',
    fieldName: 'traumaSurgery',
    textFields: [
      {displayName: 'Type of Surgery',
      fieldName: 'traumaSurgeryText'}
    ]},

    {displayName: 'Received cytotoxic chemotherapy within 90 days',
    fieldName: 'cytotoxicChemotherapy',
    textFields: []},

    {displayName: 'Received high-dose corticosteroids for ≥14 days in last 90 days',
    fieldName: 'highDoseCorticosteroids',
    infoText: 'Defined as >40 mg/day prednisone or equivalent',
    textFields: []},

    {displayName: 'Recent travel history to a foreign country',
    fieldName: 'recentTravelToForeignCountry',
    textFields: [
      {displayName: 'Which Country?',
      fieldName: 'recentTravelToForeignCountryText'}
    ]},

    {displayName: 'Received carbapenem or non-response for carbapenem in the prior 30 days',
    fieldName: 'carbapenemInPriorThirtyDays',
    textFields: []},

    {
      displayName: 'Was on ventilator at any point before taking the index culture sample',
    fieldName: 'ventilatorBeforeCulture',
    textFields: []},

    {displayName: 'Other',
    fieldName: 'bacterialInfectionRiskFactorsOther',
    textFields: [{
      displayName: 'Please Specify',
      fieldName: 'bacterialInfectionRiskFactorsOtherText'
    }]},

    {displayName: 'None',
      fieldName: 'no_carbapenem_bacterial_infection_risk_factors',
    },
  ]

  return (
    <div id="HospitalAdmissionForm">
      <Form validated={props.chartIsIncompleteModalData.length !== 0 ? true: false}>
        <FormInput
          label={'Admission Date'}
          name={'admissionDate'}
          value={admissionDate}
          type={'date'}
          xs={12}
          sm={12}
          md={8}
          lg={6}
          onChange={handleAdmissionDateChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          errorText={getHelperText('admissionDate')}
          required={true}
        />

        <SelectWithOptionalTextField
          label='Admission Type'
          options={admissionTypeOptions}
          selected={admissionType}
          text={admissionTypeOtherText}
          selectFieldName='admissionType'
          handleChange={handleAdmissionTypeChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          placeholder="Please make a selection"
          {...props}
          required={true}
        />

        <FormInput
          label={'Admission Diagnoses (please report ICD-10 codes if available): '}
          name={'admissionDiagnoses'}
          placeholder={'Enter all relevant admission diagnoses'}
          value={admissionDiagnoses}
          type={'textarea'}
          xs={12}
          sm={12}
          md={8}
          lg={6}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={true}
        />

        <CheckboxesWithOptionalTextField
          label='Any relevant pre-existing or concurrent medical conditions prior to the time of hospitalization (please check all that apply):'
          options={additionalDiagnosesOptions}
          // text={admissionTypeOtherText}
          handleTextChange={handleChange}
          handleSelect={handleAdditionalDiagnosesSelect}
          onBlur={handleBlur}
          disabled={chartForReview || savingChartPhase ? true : false }
          required={getRequired(additionalDiagnosesOptions)}
          {...props}
        />

        <br/>

        <CheckboxesWithOptionalTextField
          label='Risk factors for Carbapenem-Resistant Gram-negative bacterial infection (please check all that apply)'
          options={infectionRiskFactorsOptions}
          handleTextChange={handleChange}
          handleSelect={handleInfectionRiskFactorsSelect}
          onBlur={handleBlur}
          disabled={chartForReview || savingChartPhase ? true : false }
          required={getRequired(infectionRiskFactorsOptions)}
          {...props}
        />


        <WarningModal
          show={warningModalConfig.show}
          headerText={warningModalConfig.headerText}
          bodyText={warningModalConfig.bodyText}
          onConfirm={() => changeShowWarningModal(initialWarningModalState)}
          confirmText="OK"
          onCancel={() => changeShowWarningModal(initialWarningModalState)}
          hideCancelButton
        />


      </Form>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    chartIsIncompleteModalData: state.chartFormReducer.chartIsIncompleteModalData,
    patientChartUrl: state.chartFormReducer.patientChartUrl,
    dateDiscrepancyApproved: state.chartFormReducer.dateDiscrepancyApproved,
    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
    hospitalAdmissionInfoUrl: state.hospitalAdmissionFormReducer.hospitalAdmissionInfoUrl,
    admissionDate: state.hospitalAdmissionFormReducer.admissionDate,
    admissionType: state.hospitalAdmissionFormReducer.admissionType,
    admissionTypeOtherText: state.hospitalAdmissionFormReducer.admissionTypeOtherText,
    admissionDiagnoses: state.hospitalAdmissionFormReducer.admissionDiagnoses,
    savingChartPhase: state.chartFormReducer.savingChartPhase,

    date_of_onset: state.infectionCourseFormReducer.date_of_onset,

    //additionalDiagnoses Bools
    myocardialInfarction: state.hospitalAdmissionFormReducer.myocardialInfarction,
    congestiveHeartFailure: state.hospitalAdmissionFormReducer.congestiveHeartFailure,
    peripheralVascularDisease: state.hospitalAdmissionFormReducer.peripheralVascularDisease,
    cerebrovascularDiseaseTransientIschemicAttacks: state.hospitalAdmissionFormReducer.cerebrovascularDiseaseTransientIschemicAttacks,
    dementia: state.hospitalAdmissionFormReducer.dementia,
    chronicPulmonaryDisease: state.hospitalAdmissionFormReducer.chronicPulmonaryDisease,
    connectiveTissueDisease: state.hospitalAdmissionFormReducer.connectiveTissueDisease,
    pepticUlcerDisease: state.hospitalAdmissionFormReducer.pepticUlcerDisease,
    mildLiverDisease: state.hospitalAdmissionFormReducer.mildLiverDisease,
    moderateSevereLiverDisease: state.hospitalAdmissionFormReducer.moderateSevereLiverDisease,
    diabetesMellitusUncomplicated: state.hospitalAdmissionFormReducer.diabetesMellitusUncomplicated,
    diabetesWithEndOrganDamage: state.hospitalAdmissionFormReducer.diabetesWithEndOrganDamage,
    hemiplegia: state.hospitalAdmissionFormReducer.hemiplegia,
    moderateOrSevereRenalDisease: state.hospitalAdmissionFormReducer.moderateOrSevereRenalDisease,
    solidTumorWithoutMetastasisLastFiveYears: state.hospitalAdmissionFormReducer.solidTumorWithoutMetastasisLastFiveYears,
    metastaticSolidTumor: state.hospitalAdmissionFormReducer.metastaticSolidTumor,
    metastaticSolidTumorPrimarySite: state.hospitalAdmissionFormReducer.metastaticSolidTumorPrimarySite,
    metastaticSolidTumorMetastaticSites: state.hospitalAdmissionFormReducer.metastaticSolidTumorMetastaticSites,
    leukemia: state.hospitalAdmissionFormReducer.leukemia,
    lymphoma: state.hospitalAdmissionFormReducer.lymphoma,
    hiv: state.hospitalAdmissionFormReducer.hiv,
    hiv_treatment: state.hospitalAdmissionFormReducer.hiv_treatment,
    cysticFibrosis: state.hospitalAdmissionFormReducer.cysticFibrosis,
    bronchiectasis: state.hospitalAdmissionFormReducer.bronchiectasis,
    emphysema: state.hospitalAdmissionFormReducer.emphysema,
    muscularSkeletalAbnormalityDegenerativeDisease: state.hospitalAdmissionFormReducer.muscularSkeletalAbnormalityDegenerativeDisease,
    severeBurns: state.hospitalAdmissionFormReducer.severeBurns,
    multipleMyeloma: state.hospitalAdmissionFormReducer.multipleMyeloma,
    covid: state.hospitalAdmissionFormReducer.covid,
    febrileNeutropenia: state.hospitalAdmissionFormReducer.febrileNeutropenia,
    additionalDiagnosesOther: state.hospitalAdmissionFormReducer.additionalDiagnosesOther,
    additionalDiagnosesOtherText: state.hospitalAdmissionFormReducer.additionalDiagnosesOtherText,
    no_pre_existing_conditions: state.hospitalAdmissionFormReducer.no_pre_existing_conditions,
    pregnancy: state.hospitalAdmissionFormReducer.pregnancy,
    pregnancy_trimester: state.hospitalAdmissionFormReducer.pregnancy_trimester,

    //infectionRiskFactors Bools
    infectionRiskFactors: state.hospitalAdmissionFormReducer.infectionRiskFactors,
    carbapenemBacterialInfectionHistory: state.hospitalAdmissionFormReducer.carbapenemBacterialInfectionHistory,
    hospitalAdmissionsInPastSixMonths: state.hospitalAdmissionFormReducer.hospitalAdmissionsInPastSixMonths,
    hospitalAdmissionsInPastSixMonthsText: state.hospitalAdmissionFormReducer.hospitalAdmissionsInPastSixMonthsText,
    transplantWithinNinetyDays: state.hospitalAdmissionFormReducer.transplantWithinNinetyDays,
    traumaSurgery: state.hospitalAdmissionFormReducer.traumaSurgery,
    traumaSurgeryText: state.hospitalAdmissionFormReducer.traumaSurgeryText,
    cytotoxicChemotherapy: state.hospitalAdmissionFormReducer.cytotoxicChemotherapy,
    highDoseCorticosteroids: state.hospitalAdmissionFormReducer.highDoseCorticosteroids,
    recentTravelToForeignCountry: state.hospitalAdmissionFormReducer.recentTravelToForeignCountry,
    recentTravelToForeignCountryText: state.hospitalAdmissionFormReducer.recentTravelToForeignCountryText,
    carbapenemInPriorThirtyDays: state.hospitalAdmissionFormReducer.carbapenemInPriorThirtyDays,
    ventilatorBeforeCulture: state.hospitalAdmissionFormReducer.ventilatorBeforeCulture,
    bacterialInfectionRiskFactorsOther: state.hospitalAdmissionFormReducer.bacterialInfectionRiskFactorsOther,
    bacterialInfectionRiskFactorsOtherText: state.hospitalAdmissionFormReducer.bacterialInfectionRiskFactorsOtherText,
    no_carbapenem_bacterial_infection_risk_factors: state.hospitalAdmissionFormReducer.no_carbapenem_bacterial_infection_risk_factors,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleHospitalAdmissionChartFieldChange: (key, value) => {
      return dispatch(handleHospitalAdmissionChartFieldChange(key, value))
    },

    submitChartHospitalAdmissionInfo: (props) => {
      return dispatch(submitChartHospitalAdmissionInfo(props))
    },

    handleChartFieldChange: (key, value) => {
      return dispatch(handleChartFieldChange(key, value))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HospitalAdmissionForm)
